import {
    ACCEPT_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR,
    BannersEditMassActions,
    CHANGE_LINK_DISPLAYED_BULK_EDITOR_NEW_URL,
    CHANGE_LINK_DISPLAYED_BULK_EDITOR_SELECTED_LINK,
    CLOSE_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR,
    ON_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED,
    OPEN_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR
} from '../../../actions/banners-edit/banners-edit-mass-actions';
import { selectBannersDisplayedLinks } from '../../../selectors/bannerEdit/massActions/massActions';
import { getVisibleItems } from '../../../service/BannersEditMassActionsHelpers/BannersEditMassActionsHelpers';
import { BannersEditMassActionsState } from '../../../typings/bannersEditState';
import { State } from '../../../typings/state';

import { bannersEditMassActionsInitialState } from './banners-edit-mass-actions';

export function bannersEditMassActionsDisplayedLinkReplaceReducer(
    state: BannersEditMassActionsState = bannersEditMassActionsInitialState,
    action: BannersEditMassActions,
    fullState: State
): BannersEditMassActionsState {
    switch (action.type) {
        case ACCEPT_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR:
        case CLOSE_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR:
            return bannersEditMassActionsInitialState;
        case CHANGE_LINK_DISPLAYED_BULK_EDITOR_NEW_URL:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        newVisibleLink: action.newVisibleLink
                    }
                }
            };
        case CHANGE_LINK_DISPLAYED_BULK_EDITOR_SELECTED_LINK: {
            const displayedLinks = getVisibleItems(
                state[action.massActionId].data.selectedSourceItems,
                action.selectedSourceItems
            );

            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        selectedSourceItems: displayedLinks
                    }
                }
            };
        }
        case OPEN_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR: {
            const displayedLinks = selectBannersDisplayedLinks(fullState);

            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    visibleModalActions: {
                        ...state[action.massActionId].visibleModalActions,
                        linkDisplayedBulkReplacementEditorVisible: true
                    },
                    data: {
                        ...state[action.massActionId].data,
                        visibleItems: displayedLinks,
                        selectedSourceItems: displayedLinks.map(val => val.id)
                    }
                }
            };
        }
        case ON_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED: {
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        currentActiveRadioButtonDisplayedLinks: action.value,
                        newVisibleLink: ''
                    }
                }
            };
        }
        default:
            return state;
    }
}
